import React, { Component } from 'react';

import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';
import CurrencyInput from 'react-currency-input';
import './Despesas.css';
import Utils from '../../js/utils';

import PagarDespesa from '../../Components/PagarDespesa/PagarDespesa';

import {
    Row,
    Col,
    Spin,
    Select,
    Form,
    Checkbox,
    Button,
    Modal,
} from 'antd';

const FormItem = Form.Item;
const Option = Select.Option;

class Despesas extends Component {
    constructor(props) {
        super(props);

        this.state = {
            despesas: [],
            loading: false,
            buscando: false,
            despesaSelecionada: {},
            modalVisible: false,
            modalPagaDespesaVisible: false,
            cdTitulo: 0,
            stEfetuarPagamento: 0
        }                

        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
        this.usuario = this.dadosProvider.getDadosUsuario();
        this.utils = new Utils();
    }

    componentWillMount() {
        this.getDespesas();
    }

    componentDidUpdate(){
        if(this.state.modalVisible != this.props.modalVisible){
            this.props.form.resetFields();
            this.setState({modalVisible: this.props.modalVisible});
        }
    }

    getDespesas = ()=>{        

        var dados = {
            "uiFilial": this.dadosProvider.getUiFilial(),
            "cripto": this.dadosProvider.getDadosUsuario().Cripto
        };

        this.setState({ buscando: true });

        this.dataService.GetListaCarteiraDespesa(dados, (retorno) => {
            if (retorno.length > 0) {
                this.setState({ buscando: false });
                this.setState({ despesas: retorno});

                // console.log(retorno);
            }

        }, (erro) => {
            console.error(erro);
            this.setState({ buscando: false });
        });
    }

    emitirDespesaAvulsa = ()=>{        
        this.props.form.validateFields((err, values) => {
            if (!err) {
                var dados = {
                    "uiFilial": this.dadosProvider.getUiFilial(),
                    "cripto": this.dadosProvider.getDadosUsuario().Cripto,
                    "cdDespesa": this.state.despesaSelecionada["CdDespesa"] 
                }
        
                this.setState({ loading: true });
        
                this.dataService.EmitirDespesaAvulsa(dados, (retorno) => {
        
                    this.setState({ loading: false });
        
                    if (retorno.Status === "1") {
                        if(values.stEfetuarPagamento){
                            this.abrePagarDespesa(retorno.Id, values.stEfetuarPagamento);
                        }else{
                            Modal.success({
                                title: 'Sucesso',
                                content:(<div dangerouslySetInnerHTML={{ __html: this.utils.HtmlDecode(retorno.Msg) }} />)                    
                            });
                            
                            this.handleCancelDespesa(true);
                        }
                    }else {
                        Modal.error({
                            title: 'Erro',
                            content:(<div dangerouslySetInnerHTML={{ __html: this.utils.HtmlDecode(retorno.Msg) }} />)
                        });
                    }
                }, (erro) => {
                    console.error(erro);
                    this.setState({ loading: false });
                });
            }
        });
    }

    onDespesaChange = (value) =>{
        this.setState({
            despesaSelecionada: this.state.despesas[value]
        })
    }

    handleCancelDespesa = (stReload) => {
        this.setState({
            despesaSelecionada: {}
        });
        
        if(stReload){
            this.props.onClose(stReload);
        }
    }

    handleCancelPagarDespesa = (stReload = false) => {
        this.setState({
            modalPagaDespesaVisible: false,
        });

        if(stReload){
            this.props.onClose();
        }
    }

    abrePagarDespesa = (cdTitulo, stEfetuarPagamento) =>{
        this.setState({modalPagaDespesaVisible: true});
        this.setState({cdTitulo: cdTitulo, stEfetuarPagamento: stEfetuarPagamento});
    }

    render(){
        const { getFieldDecorator } = this.props.form;
        return(
            <Modal
                title="Adicionar Despesa"
                visible={this.state.modalVisible}
                onCancel={this.handleCancelDespesa}
                footer={null}
                destroyOnClose={true}>
                {this.state.buscando ?
                    (<Row>
                        <Col className="imageRadio">
                            <div className="divSpin">
                                <Spin className="imageSpin" />
                            </div>
                        </Col>
                    </Row>) 
                    :                 
                (
                    <div>
                        <PagarDespesa modalVisible={this.state.modalPagaDespesaVisible} onClose={(stReload)=>{this.handleCancelPagarDespesa(stReload)}} cdTitulo={this.state.cdTitulo}></PagarDespesa>

                        <Row className="rowSpace" justify="center">
                            <Col className="text-center">Saldo Disponivel: {this.state.simboloMoeda} {this.props.saldoDisponivel}</Col>
                        </Row>
                        <Form name="formAdicionarDespesa" className="formAdicionarDespesa">
                            <Row>
                                <FormItem
                                    label="Despesa">
                                    {getFieldDecorator('cdDespesa', {
                                        rules: [{
                                            required: true, message: 'Selecione uma depesa',
                                        }]
                                    })(
                                        <Select
                                        onChange={this.onDespesaChange}>
                                            {this.state.despesas.map((despesa, index) => <Option key={index}>{despesa["DsDespesa"]}</Option>)}
                                        </Select>
                                    )}                            
                                </FormItem>
                            </Row>
                            <Row>
                                <FormItem label="Valor">
                                    <span className="ant-input-group-wrapper">
                                        <span className="ant-input-wrapper ant-input-group">
                                            <span className="ant-input-group-addon">
                                                {this.usuario.DsMoedaPadrao}
                                            </span>
                                            <CurrencyInput decimalSeparator="," thousandSeparator="." className="ant-input" name="VlDespesa" readOnly
                                                value={this.state.despesaSelecionada["VlDespesa"]}
                                            />
                                        </span>
                                    </span>
                                </FormItem>
                            </Row>
                            <Row>
                                <FormItem>
                                {getFieldDecorator('stEfetuarPagamento', {})(
                                    <Checkbox name="stEfetuarPagamento">Deseja efetuar o pagamento agora?</Checkbox>
                                )}                                     
                                </FormItem>
                            </Row>
                        </Form>        
                        <Row className="buttonRow" gutter={16}>
                            <Col sm={{ span: 24 }}>
                                <Button size="large" type="primary" loading={this.state.loading} onClick={this.emitirDespesaAvulsa}>Adicionar</Button>
                            </Col>
                        </Row>
                    </div>  
                )}
            </Modal>
        )
    }
}

export default Form.create()(Despesas);


// WEBPACK FOOTER //
// ./src/Components/Despesas/Despesas.js